export class SessionEventListeners {
  constructor(module) {
    this.module = module;
  }

  addAllEventListeners() {
      this.addEventListenersForContainer();

      this.module.filterRows.forEach((filterRow) => {
        filterRow.addEventListener("click", (e) => {
          e.preventDefault();
          this.module.filter.toggleFilter(e.target, filterRow.dataset.for);
        });
      });

      if (!this.module.reshuffleButton) return;

      this.module.reshuffleButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.module.reshuffler.reshuffle();
      });
  }

  addEventListenersForContainer() {
    if (!(this.module.container && this.module.sessions && this.module.target)) return;

    this.module.sessions.forEach((session) => this.addEventListenersForSession(session));
  }

  addEventListenersForSession(session) {
    const clickableArea = session.querySelector(".session__clickable-area");
    const content = session.querySelector(".session__collapsed-content");

    clickableArea.addEventListener("click", () =>
      this.module.details.setActive(session)
    );

    content.addEventListener("click", () =>
      this.module.details.setActive(session)
    );
  }
}
